import React, { Component } from "react"
import {
	Alert,
	Button,
	Col,
	Glyphicon,
	Grid,
	Panel,
	Row,
} from "react-bootstrap"
import * as firebase from "firebase"
import "./Pro.css"
import { signIn } from "./user"
import request from "./request"
import { withRouter } from "react-router-dom"
import * as SmoothScroll from "smooth-scroll"

class Pro extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isTrialLoading: false,
			isPurchasing: false,
			errorMessage: null,
		}
	}

	render() {
		const { uid, plan, price, trialActivatedAt } = this.props
		const { isTrialLoading, isPurchasing, errorMessage } = this.state
		return (
			<div>
				<div>
					<h1 className="plans-top-text">Plans & Pricing</h1>
					{plan !== "pro" && trialActivatedAt ? null : (
						<p className="plans-top-text-discount">
							Free 7 day trial. No credit card required!
						</p>
					)}
				</div>
				<div className="price-grid">
					<Grid>
						<Row>
							<Col md={6}>
								<Panel>
									<div className="plan">
										<p className="plans-title">Pro</p>
										<p className="plans-price">
											<Glyphicon glyph="bitcoin" className="bitcoin-icon" />
											{price * 12}
										</p>
										<p className="plans-price-detail">Per year</p>
										<p>For crypto traders</p>
										<p>
											Display <b>full precision</b> for calculated gains and
											values
										</p>
										<p>
											Convert price values to <b>USD</b>, <b>EUR</b>, <b>BTC</b>,
											and <b>ETH</b>
										</p>
										<p>
											<b>Sort</b> assets by market value and % of portfolio
										</p>
										<p>
											<b>Filter</b> assets by name and exchange
										</p>
										{plan !== "pro" && trialActivatedAt ? (
											<div className="buy-botton-container">
												<Button
													className="buy-botton-inline"
													disabled={isPurchasing}
													bsStyle="primary"
													onClick={this.purchaseHandler(uid, 12)}
												>
													Pro (1 year) -{" "}
													<Glyphicon
														glyph="bitcoin"
														className="plan-expired-bitcoin-icon"
													/>
													{price * 12}
												</Button>
											</div>
										) : (
											<Button
												className="buy-button"
												bsStyle="primary"
												bsSize="large"
												disabled={plan === "pro" || isTrialLoading}
												onClick={
													!isTrialLoading
														? this.startTrialButtonClickHandler(uid)
														: null
												}
											>
												{plan === "pro"
													? "You Have Pro"
													: isTrialLoading
														? "Starting Trial..."
														: "Start Trial"}
											</Button>
										)}

										{errorMessage !== null ? (
											<Alert bsSize="danger">{errorMessage}</Alert>
										) : null}
									</div>
								</Panel>
							</Col>
							<Col md={6}>
								<Panel>
									<div className="plan">
										<p className="plans-title">Free</p>
										<p className="plans-price">
											<Glyphicon glyph="bitcoin" className="bitcoin-icon" />
											0
										</p>
										<p className="plans-price-detail">Per year</p>
										<p>For crypto holders</p>
										<p>
											<b>Automatic portfolio sync</b> for Kraken, Bittrex, and
											GDAX
										</p>
										<p>
											Calculates asset <b>average cost</b> and{" "}
											<b>unrealized gain/loss</b>
										</p>
										<p>
											Display <b>fees</b> and <b>book value</b> of transactions
										</p>
										<p>
											<b>Mobile friendly</b> for phones and tablets
										</p>
									</div>
								</Panel>
							</Col>
						</Row>
					</Grid>
				</div>
			</div>
		)
	}

	startTrialButtonClickHandler(uid) {
		return async event => {
			this.setState({
				isTrialLoading: true,
			})
			try {
				const auth = firebase.auth()
				if (auth.currentUser === null || auth.currentUser.email === null) {
					const user = await signIn()
					uid = user.uid
				}
				await request(uid, { action: "startTrial" })
				this.setState({
					errorMessage: null,
				})
				const scroll = new SmoothScroll()
				scroll.animateScroll(0)
			} catch (error) {
				this.setState({
					errorMessage: error.message,
				})
				throw error
			} finally {
				this.setState({
					isTrialLoading: false,
				})
			}
		}
	}

	purchaseHandler(uid, months) {
		return async () => {
			if (this.state.isPurchasing) {
				return
			}
			this.setState({
				isPurchasing: true,
				errorMessage: null,
			})
			try {
				const result = await request(uid, {
					action: "createInvoice",
					payload: {
						months,
					},
				})
				window.localStorage.setItem("isPurchasing", "true")
				window.location.replace(result.url)
			} catch (error) {
				this.setState({
					errorMessage: error.message,
				})
				throw error
			} finally {
				this.setState({
					isPurchasing: false,
				})
			}
		}
	}
}

export default withRouter(Pro)



// WEBPACK FOOTER //
// ./src/Pro.js